import {ElementStyles} from "./ElementStyles";
import {useState} from "react";
import deleteIcon from "../../img/delete.png";

const styles={
  container: {
    borderRadius: ElementStyles.borderRadius,
    boxSizing: "inherit",
    color: ElementStyles.color,
    padding: ElementStyles.paddingLabels,
    minHeight: ElementStyles.height,
    display: "flex",
    alignItems: "center",
    textWrap: "noWrap",
    justifyContent: "space-between",
    flexGrow: 1
  },
  tooltip: {
    position: "absolute",
    borderRadius: ElementStyles.borderRadius,
    boxSizing: "inherit",
    color: ElementStyles.color,
    padding: ElementStyles.paddingLabels,
    minHeight: ElementStyles.height,
    alignItems: "center",
    whiteSpace: "pre",
    background: ElementStyles.color2,
    zIndex: 1
  },
  select:{
    width: "2rem",
    height: "2rem",
    background: ElementStyles.color,
    borderRadius: ElementStyles.borderRadius,
    margin: "auto",
  },
  selected:{
    width: "1.5rem",
    height: "1.5rem",
    background: ElementStyles.accent,
    borderRadius: ElementStyles.borderRadius,
    marginTop: "0.25rem",
    marginLeft: "0.25rem",
  }
}

export default function LabelSelectableWeex({children, style = null, tooltip, onDelete, selected, setSelected, ...props}){
  const [visible, setVisible] = useState("none")
  // const [selected, setSelected] = useState(false)
  const [pos, setPos] = useState(0)

  return (
    <div onMouseEnter={(e) => {
      setVisible("block");
      const rect = e.target.getBoundingClientRect();
      setPos(rect.bottom + window.scrollY);
    }} onMouseLeave={() => setVisible("none")}
         style={{display: "flex", flexDirection: "row", position: "relative"}}
         onClick={()=>setSelected(!selected)}
    >
      <div style={styles.select}>{selected?<div style={styles.selected}/>:null}</div>
      <label style={{...styles.container, ...style}} {...props}>
        {children}
        {onDelete&&visible==="block"&&<img className={"icon"} src={deleteIcon} style={{cursor: "pointer", height: "2rem", width: "auto"}}
              alt={"delete"} onClick={onDelete}/>}
      </label>
      {tooltip && <span style={{display: visible, ...styles.tooltip, top: "calc(100% + 5px)", maxWidth: "100%", whiteSpace: "break-spaces", textAlign: "left"}}>{tooltip}</span>}
    </div>
  );
};

